<div class="flex flex-col">
  <mat-toolbar class="Breadcrumbs">
    <button
      mat-icon-button
      droppable
      class="Breadcrumb__button"
      [dragOverClass]="'Breadcrumb__button--dragover'"
      [dropScope]="getDropScope(rootBucket)"
      (onDrop)="onFileMoved(rootBucket, $event)"
      (click)="getRoot()"
    >
      <mat-icon>home</mat-icon>
    </button>
    <div *ngFor="let bucket of breadcrumbs; let i = index" class="Breadcrumb">
      <mat-icon class="Breadcrumb__delimiter">keyboard_arrow_right</mat-icon>
      <button
        mat-button
        droppable
        class="Breadcrumb__button"
        [dropScope]="getDropScope(bucket)"
        [dragOverClass]="'Breadcrumb__button--dragover'"
        (click)="viewBucketFromBreadcrumbs(bucket, i)"
        (onDrop)="onFileMoved(bucket, $event)"
      >
        {{ bucket.title }}
      </button>
    </div>
    <div class="flex-1"></div>
    <span class="mat-caption"
      >{{ 'MEDIA.SORT_BY' | translate }}: {{ sorting.label | translate }} ({{
        sorting.order === 'asc' ? ('MEDIA.DOWN' | translate) : ('MEDIA.UP' | translate)
      }})</span
    >
    <button mat-icon-button [matMenuTriggerFor]="sortMenu">
      <mat-icon>sort</mat-icon>
    </button>
    <button mat-icon-button (click)="setActiveView('grid')" [disabled]="activeView === 'grid'"><mat-icon>view_module</mat-icon></button>
    <button mat-icon-button (click)="setActiveView('list')" [disabled]="activeView === 'list'"><mat-icon>list</mat-icon></button>
    <button mat-icon-button (click)="toggleSearch()"><mat-icon>search</mat-icon></button>
  </mat-toolbar>

  <mat-toolbar *ngIf="IS_SEARCHING">
    <form class="Search-form">
      <input placeholder="Sök filer och mappar" #searchField [formControl]="searchForm" class="Search-form__input" />
    </form>
  </mat-toolbar>

  <mat-grid-list [cols]="cols" gutterSize="10px" class="Files flex-1" *ngIf="activeView === 'grid'">
    <mat-grid-tile
      *ngFor="let item of items"
      class="File"
      droppable
      draggable
      [dragData]="item"
      [dragOverClass]="'File--selected'"
      [dragScope]="getDragScope(item)"
      [dropScope]="getDropScope(item)"
      [class.File--selected]="isSelected(item)"
      (onDrop)="onFileMoved(item, $event)"
      (click)="toggleSelectItem(item, $event)"
      (dblclick)="itemSelected(item)"
    >
      <div class="File__inner">
        <mat-icon class="File__icon" *ngIf="!item.isImage()">{{ item.getIconString() }}</mat-icon>
        <img class="File__preview" [src]="item.getFilePath({ w: 150 }) | secureImg" *ngIf="item.isImage()" />
        <h3 class="File__title">{{ item.title }}</h3>
      </div>
    </mat-grid-tile>
  </mat-grid-list>
  <aw-file-list
    [display]="activeView === 'list'"
    [items]="items"
    [selectedItems]="selectedItems"
    (doubleClick)="itemSelected($event)"
    (select)="toggleSelectItem($event.row, $event.event)"
  ></aw-file-list>

  <div class="w-[250px]">
    <app-paginator-dumb [collection]="{ page: currentPage, next: canGoNextPage }" (onGoToPage)="goToPage($event)"></app-paginator-dumb>
  </div>
  <div class="Library-loader flex items-center justify-center flex-1" [hidden]="!IS_LOADING">
    <mat-spinner class="Library-loader__spinner" diameter="50"></mat-spinner>
  </div>
</div>

<mat-menu #sortMenu="matMenu" xPosition="before">
  <button
    mat-menu-item
    *ngFor="let item of mediaConfig.sorting"
    [class.mat-menu-item-highlighted]="item.value === sorting.value"
    (click)="applySorting(item)"
    class="flex items-center justify-start"
  >
    <mat-icon>{{ item.icon }}</mat-icon>
    <span class="flex-1">{{ item.label | translate }}</span>
    <mat-icon [hidden]="sorting.value !== item.value">check</mat-icon>
  </button>
</mat-menu>
